// TODO: remove ts-nocheck
// @ts-nocheck
import { Scripts } from "components/scripts";
import { AppProps } from "next/app";
import React from "react";
import { initializeEnv, EnvConfig } from "app/config";
import Provider from "components/provider";
import { getConfig } from "contracts/util";
import { getEnv } from "app/config";
import { getChainWhitelist } from "util/get-chain-whitelist";

const getEnvFromServer = () => ({
  GTAG_ID: process.env.GTAG_ID,
  NEXT_PUBLIC_APP_VERSION: process.env.NEXT_PUBLIC_APP_VERSION,
  CHAIN_WHITELIST: process.env.CHAIN_WHITELIST,
  NEXT_PUBLIC_WC_PROJECT_ID: process.env.NEXT_PUBLIC_WC_PROJECT_ID,
});

const App = ({ Component, pageProps, env }: AppProps & { env: EnvConfig }) => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.info(`version: ${process.env.NEXT_PUBLIC_APP_VERSION}`);
  }, []);

  const envValues = env || getEnv();

  initializeEnv(envValues);

  const config = getConfig({
    whitelistId: getChainWhitelist(),
  });

  return (
    <>
      <Scripts GTAG_ID={env?.GTAG_ID} />
      <Provider config={config}>
        <Component {...pageProps} />
      </Provider>
    </>
  );
};

App.getInitialProps = async ({ ctx }: { ctx: { req?: unknown } }) => {
  const isSsr = Boolean(ctx.req);
  const env = getEnvFromServer();
  return {
    env: isSsr ? env : undefined,
  };
};

export default App;
